import { render, staticRenderFns } from "./CampaignContainer.vue?vue&type=template&id=32c32564&scoped=true&"
import script from "./CampaignContainer.vue?vue&type=script&lang=js&"
export * from "./CampaignContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c32564",
  null
  
)

export default component.exports